import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getBrandsStart,
  getBrandsSuccess,
  getBrandsFailed
} from 'redux/actions/brands';
import {
  getMasterCatalogProductsStart,
  getMasterCatalogProductsSuccess,
  getMasterCatalogProductsFailed
} from 'redux/actions/products';
import {
  getCatalogStoreCodesStart,
  getCatalogStoreCodesFailed,
  getCatalogStoreCodesSuccess
} from 'redux/actions/admin';
import { serialize } from '../helpers/api';


export const getBrands = async ({ dispatch, fullfilledByDermpro = 0, isAffiliate = 0,  skuLike = '' }) => {
  try {
    dispatch(getBrandsStart());
    const params = {};
    fullfilledByDermpro && (params.fullfilledByDermpro = fullfilledByDermpro);
    isAffiliate && (params.isAffiliate = isAffiliate);
    skuLike && (params.skuLike = skuLike.toUpperCase());

    const { data } = await api.get(`${shopManagerApi}/catalog/brands${serialize(params)}`);
    dispatch(getBrandsSuccess(data, fullfilledByDermpro, isAffiliate, skuLike));
  } catch (e) {
    dispatch(getBrandsFailed());
  }
};

export const getMasterCatalogProductsApi = async ({dispatch, brand, name, fullfilledByDermpro = 0, isAffiliate = 0, brandType}) => {
  try {
    dispatch(getMasterCatalogProductsStart());
    const params = {};
    brand && (params.brand = brand);
    name && (params.name = name);
    fullfilledByDermpro && (params.fullfilledByDermpro = fullfilledByDermpro);
    isAffiliate && (params.isAffiliate = isAffiliate);

    const { data } = await api.get(`${shopManagerApi}/catalog/products${serialize(params)}`);
    dispatch(getMasterCatalogProductsSuccess(data, brand, brandType));
  } catch (e) {
    dispatch(getMasterCatalogProductsFailed());
  }
};

export const getCatalogStoreCodesAPI = async ({dispatch}) => {
  try {
    dispatch(getCatalogStoreCodesStart());
    const { data } = await api.get(`${shopManagerApi}/catalog/store-codes`);
    dispatch(getCatalogStoreCodesSuccess(data));
  } catch (e) {
    dispatch(getCatalogStoreCodesFailed(e));
  }
};
